<!--调拨弹出框-->
<template>
  <div class="TransferPop" style="background-color: #f5f5f5">
    <div class="column-block">
      <van-form class="form" ref="formRef">
        <van-cell-group inset style="margin: 1vh 1.2vh 0 1.2vh">
          <span style="margin-left: 0vh; display: block; color: #000">
            <div class="column-block">
              <van-icon class="lable_icon" />调拨资产
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.asset_name"
                name="调拨资产"                
                is-link
                placeholder="请选择调拨资产"
                @click="pageConfig.showAssetListPop = true"
                :rules="[{ required: true, message: '请选择调拨资产' }]"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
              />
              <van-popup
                v-model:show="pageConfig.showAssetListPop"
                position="bottom"
                :style="{ height: '90%' }"
                round
              >
                <AssetList
                  :apply_emp_id="pageConfig.apply_emp_id"
                  :company_id="pageConfig.company_id"
                  @onclose="methods.selectAsset"
                ></AssetList>
              </van-popup>
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />资产代码
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.asset_code"
                name="资产代码"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />原保管部门
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.custodian_dept_name"
                name="原保管部门"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />原保管人
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.custodian_emp_name"
                name="原保管人"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />原资产状态
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.asset_status_name"
                name="原资产状态"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />原位置
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.asset_location"
                name="原位置"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />原站点
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.station_code"
                name="原站点"
                readonly
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />新保管人
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_custodian_emp_name"
                name="新保管人"
                readonly                
                is-link
                @click="pageConfig.showEmpSelect = true"
                placeholder="请选择新保管人"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
              />
              <van-popup
                v-model:show="pageConfig.showEmpSelect"
                position="bottom"
                round
                :style="{ height: '80%', overflow: 'hidden' }"
              >
                <EmpSelect @onSelectEmp="methods.onSelectEmp"></EmpSelect>
              </van-popup>
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />新保管部门
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_custodian_dept_name"
                name="新保管部门"
                is-link
                readonly
                @click="pageConfig.showDept = true"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
              />
              <!-- 选择部门弹框 -->
              <van-popup
                v-model:show="pageConfig.showDept"
                position="bottom"
                round
              >
                <van-picker
                  :columns="pageConfig.deptList"
                  @confirm="methods.deptConfirm"
                  @cancel="pageConfig.showDept = false"
                >
                  <!-- 部门选择器自定义标题头 -->
                  <template #title>
                    <van-search
                      v-model="deptName"
                      placeholder="请输入部门名称"
                      @update:model-value="methods.deptSearchupdate"
                    />
                  </template>
                  <!-- 自定义部门选择器内容 -->
                  <template #option="option">
                    <div>{{ option.dept_code + '-' + option.dept_name }}</div>
                  </template>
                </van-picker>
              </van-popup>
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />新资产状态
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_asset_status_name"
                name="新资产状态"
                @click="pageConfig.showAssetStatusPop = true"
                placeholder="请选择新资产状态"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
                readonly
                is-link
              />

              <van-popup
                v-model:show="pageConfig.showAssetStatusPop"
                position="bottom"
                round
              >
                <van-picker
                  :columns="pageConfig.assetStatusList"
                  @confirm="methods.changeAssetStatus"
                  @cancel="pageConfig.showAssetStatusPop = false"
                >
                </van-picker>
              </van-popup>
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />新位置
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_asset_location_name"
                name="新位置"
                readonly
                is-link
                @click="pageConfig.showNewAssetLocationPop = true"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
                placeholder="请选择新位置"
              />
              <van-popup
                v-model:show="pageConfig.showNewAssetLocationPop"
                position="bottom"
                round
              >
                <van-picker
                  :columns="pageConfig.locationList"
                  @confirm="methods.changeNewAssetLocation"
                  @cancel="pageConfig.showNewAssetLocationPop = false"
                >
                </van-picker>
              </van-popup>
            </div>
             <div class="column-block">
              <van-icon class="lable_icon" />新位置补充
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_asset_location_supplement"
                name="新位置补充"
                :disabled="pageConfig.is_mfg=='Y'?true:false"
                placeholder="请输入新位置补充"
              />
            </div>
            <div class="boxContent"></div>
            <div class="column-block">
              <van-icon class="lable_icon" />新站点
              <van-field
                style="padding-top: 0"
                v-model="pageConfig.new_station_name"
                name="新站点"
                @click="pageConfig.showNewStationPop = true"
                placeholder="请选择新站点"
                :style="{ '--van-field-input-text-color': '#1989fa' }"
                readonly                
                is-link
              />
              <van-popup
                v-model:show="pageConfig.showNewStationPop"
                position="bottom"
                round
              >
                <van-picker
                  :columns="pageConfig.stationList"
                  @confirm="methods.changeNewStation"
                  @cancel="pageConfig.showNewStationPop = false"
                >
                </van-picker>
              </van-popup>
            </div>
          </span>
        </van-cell-group>
      </van-form>
    </div>
    <div class="bottom" style="z-index: 100">
      <van-button
        type="primary"
        block
        style="border-radius: 10px; margin-top: 1vh"
        @click="methods.saveChange"
        >保存
      </van-button>
    </div>
  </div>
</template>
<script>
import { reactive, ref, onMounted } from 'vue'
import { Toast } from 'vant'
import EmpSelect from '@/components/Emp/empSelect.vue'
import AssetList from './assetList.vue'
import { GetDictData,CallIPassService } from '@/api/oawfs.js'
import { GetvalidYearDepartment } from '@/api/ehr_emp.js' //emp的接口

export default {
  props: ['rowdata', 'apply_emp_id','company_id'],
  components: { AssetList, EmpSelect },
  setup(props, { emit }) {
    //页面参数
    const pageConfig = reactive({
      apply_emp_id: props.apply_emp_id,
      company_id: props.company_id,
      rowdata: props.rowdata,
      showAssetListPop: false,
      asset_id: '', //资产id
      asset_name: '', //资产名称
      asset_code: '', //资产代码
      custodian_dept_id: '', //保管部门id
      custodian_dept_name: '', //保管部门名称
      custodian_dept_code: '', //保管部门
      custodian_emp_name: '', //保管人名称
      custodian_emp_code: '', //保管人代码
      custodian_emp_id: '', //保管人id
      asset_status: '', //原资产状态
      asset_status_name: '', //原资产状态
      asset_location: '', //原位置
      station_code: '', //原站点
      new_custodian_emp_name: '', //新保管人
      new_custodian_emp_code: '', //新保管人
      new_custodian_emp_id: '', //新保管人
      new_custodian_dept_name: '', //新保管部门
      new_custodian_dept_code: '', //新保管部门
      new_custodian_dept_id: '', //新保管部门
      new_asset_status_name: '', //新资产状态
      new_asset_status: '', //新资产状态
      new_asset_location: '', //新位置
      new_asset_location_supplement: '', //新位置补充
      new_asset_location_name: '', //新位置名称
      is_mfg: '', //是否制造
      new_station_name: '', //新站点
      assetStatusList: [
        { text: '使用中', value: '00' },
        { text: '闲置', value: '04' },
      ],
      showEmpSelect: false, //选择保管人弹窗
      showAssetStatusPop: false, //选择资产状态弹窗
      showNewStationPop: false, //选择站点弹窗
      stationList: [], //站点列表
      deptList: [], //部门列表
      showDeptList: false, //选择部门弹窗
      showNewAssetLocationPop: false, //选择新位置弹窗
      locationList: [], //位置列表
    })
    //内置函数
    const methods = {
      init: function () {
        //获取站点字典
        methods.getStationDict()
        //绑定默认数据
        methods.bindRowdata()
        //获取位置列表
        methods.getLocationList()
      },
      //绑定默认数据
      bindRowdata: function () {
        if (props.rowdata.asset_id) {
          pageConfig.asset_id = props.rowdata.asset_id //资产id
          pageConfig.asset_name = props.rowdata.asset_name //资产名称
          pageConfig.asset_code = props.rowdata.asset_code //资产代码
          pageConfig.custodian_dept_id = props.rowdata.custodian_dept_id //保管部门id
          pageConfig.custodian_dept_name = props.rowdata.custodian_dept_name //保管部门名称
          pageConfig.custodian_emp_name = props.rowdata.custodian_emp_name //保管人名称
          pageConfig.custodian_emp_id = props.rowdata.custodian_emp_id //保管人id
          pageConfig.asset_status = props.rowdata.asset_status //原资产状态
          pageConfig.asset_status_name = props.rowdata.asset_status_name //原资产状态
          pageConfig.asset_location = props.rowdata.asset_location //原位置
          pageConfig.station_code = props.rowdata.station_code //原站点
          pageConfig.new_custodian_emp_name =
            props.rowdata.new_custodian_emp_name //新保管人
          pageConfig.new_custodian_emp_id = props.rowdata.new_custodian_emp_id //新保管人
          pageConfig.new_custodian_dept_name =
            props.rowdata.new_custodian_dept_name //新保管部门
          pageConfig.new_custodian_dept_id = props.rowdata.new_custodian_dept_id //新保管部门
          pageConfig.new_asset_status_name = props.rowdata.new_asset_status_name //新资产状态
          pageConfig.new_asset_status = props.rowdata.new_asset_status //新资产状态
          pageConfig.new_asset_location = props.rowdata.new_asset_location //新位置
          pageConfig.new_station_name = props.rowdata.new_station_name //新站点
          pageConfig.new_station_code = props.rowdata.new_station_code //新站点
          pageConfig.new_asset_location_name = props.rowdata.new_asset_location.split('-')[0] //新位置
          if(props.rowdata.new_asset_location.indexOf('-')>0){
            pageConfig.is_mfg='N'
            pageConfig.new_asset_location_supplement = props.rowdata.new_asset_location.split('-').slice(1).join('-') //新位置补充
          }else{
            pageConfig.is_mfg='Y'
          }

        } else {
          pageConfig.showAssetListPop = true
        }
      },
      //选择资产
      selectAsset: function (item) {
        if (item) {
          pageConfig.asset_id = item.id //资产id
          pageConfig.asset_name = item.asset_name //资产名称
          pageConfig.asset_code = item.asset_code //资产代码
          pageConfig.custodian_dept_id = item.custodian_dept_id // 保管部门id
          pageConfig.custodian_dept_name = item.custodian_dept_name // 保管部门名称
          pageConfig.custodian_emp_name = item.custodian_emp_name //保管人名称
          pageConfig.custodian_emp_id = item.custodian_emp_id //保管人id
          pageConfig.asset_status = item.asset_status //原资产状态
          pageConfig.asset_status_name = methods.getAssetStatusName(
            item.asset_status,
          ) //原资产状态
          pageConfig.asset_location = item.asset_location //原位置
          pageConfig.station_code = item.station_code //原站点
          pageConfig.station_name = methods.getStationName(item.station_code) //原站点
          pageConfig.new_custodian_dept_id = item.custodian_dept_id //新保管部门id
          pageConfig.new_custodian_dept_name = item.custodian_dept_name //保管部门名称
          pageConfig.new_custodian_dept_code =  item.custodian_dept_name?.split('-')[0] //保管部门代码
          pageConfig.new_custodian_emp_id = item.custodian_emp_id //保管人名称
          pageConfig.new_custodian_emp_name = item.custodian_emp_name //保管人名称
          pageConfig.new_custodian_emp_code = item.custodian_emp_name?.split('-')[0] //保管人代码
          pageConfig.new_asset_status = item.asset_status //新资产状态
          pageConfig.new_asset_status_name = methods.getAssetStatusName(
            item.asset_status,
          ) //原资产状态
          pageConfig.new_station_code = item.station_code //新站点
          pageConfig.new_station_name = methods.getStationName(
            item.station_code,
          ) //新站点
          pageConfig.new_asset_location_name = item.asset_location?.split('-')[0] //新位置
          if(item.asset_location&&item.asset_location.indexOf('-')>0){            
            pageConfig.is_mfg='N'
            pageConfig.new_asset_location_supplement = item.asset_location.split('-')[1] //新位置补充
          }else{
            pageConfig.is_mfg='Y'
          }
          //选择新资产位置
          methods.changeNewAssetLocation({value:pageConfig.new_asset_location_name,text:pageConfig.new_asset_location_name})
        }
        pageConfig.showAssetListPop = false
      },
      //部门搜索框筛选函数
      fuzzyDeptQuery(list, keyWord) {
        var reg = new RegExp(keyWord, 'i')
        var arr = []
        for (var i = 0; i < list.length; i++) {
          if (reg.test(list[i].dept_code + '-' + list[i].dept_name)) {
            arr.push(list[i])
          }
        }
        return arr
      },
      //部门搜索框值改变触发
      deptSearchupdate(e) {
        GetvalidYearDepartment().then((res) => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          pageConfig.deptList = res.data.filter((x) => x.dept_type == '1' && x.company_id == pageConfig.company_id)
          pageConfig.deptList = methods.fuzzyDeptQuery(pageConfig.deptList, e)
        })
      },
      //选择部门
      deptConfirm: function (item) {
        pageConfig.new_custodian_dept_id = item.id //保管部门id
        pageConfig.new_custodian_dept_code = item.dept_code //保管部门
        pageConfig.new_custodian_dept_name = item.dept_code+'-'+item.dept_name //保管部门
        pageConfig.showDept = false
      },
      //获取资产状态
      getAssetStatusName: function (code) {
        const matchItem = pageConfig.assetStatusList.find(
          (item) => item.value === code,
        )
        return matchItem?.text || ''
      },
      //获取站点名称
      getStationName: function (code) {
        const matchItem = pageConfig.stationList.find(
          (item) => item.value === code,
        )
        return matchItem?.text || ''
      },
      //获取站点字典
      getStationDict: function () {
        pageConfig.stationList = []
        GetDictData({ dict_type: 'gps_station_code' }).then((res) => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          res.data.forEach((element) => {
            pageConfig.stationList.push({
              text: element.dict_label,
              value: element.dict_value,
            })
          })
        })
      },      
      //获取资产位置列表
      getLocationList:function(){
        pageConfig.locationList=[]
        CallIPassService('eam1006',{}).then(res=>{
          if(res.code == 200){
            const data = JSON.parse(res.data)
            data.forEach(item => {
              pageConfig.locationList.push({text:item.location_name,value:item.location_name,is_mfg:item.is_mfg,location_mapping:item.location_mapping})
            });
            
          }
        })
      },
      //切换新资产位置
      changeNewAssetLocation: function (res) {
        let location = pageConfig.locationList.filter(x=>x.value == res.value)
        if(location&&location.length>0){
          pageConfig.is_mfg=location[0].is_mfg   
          pageConfig.location_mapping = location[0].location_mapping       
        }
        pageConfig.new_asset_location_name = res.text //新资产位置
        if(pageConfig.is_mfg=='Y'){
          pageConfig.new_asset_location_supplement=''
        }        
        pageConfig.showNewAssetLocationPop = false
      },
      //选择保管人
      onSelectEmp: function (item) {
        pageConfig.showEmpSelect = false
        pageConfig.new_custodian_emp_name = item.emp_code + '-' + item.emp_name //新保管人
        pageConfig.new_custodian_emp_code = item.emp_code //新保管人
        pageConfig.new_custodian_emp_id = item.user_id //新保管人
        pageConfig.new_custodian_dept_name = item.dept_name //新保管部门
        pageConfig.new_custodian_dept_code = item.dept_code //新保管部门
        pageConfig.new_custodian_dept_id = item.dept_id //新保管部门
      },
      //选择资产状态
      changeAssetStatus: function (item) {
        pageConfig.new_asset_status_name = item.text //新资产状态
        pageConfig.new_asset_status = item.value //新资产状态
        pageConfig.showAssetStatusPop = false
      },
      //选择新站点
      changeNewStation: function (item) {
        pageConfig.new_station_name = item.text //新站点
        pageConfig.new_station_code = item.value //新站点
        pageConfig.showNewStationPop = false
      },
      //保存
      saveChange: function () {   
          if(pageConfig.is_mfg=='Y'){
            pageConfig.new_asset_location = pageConfig.new_asset_location_name
          }else{
            pageConfig.new_asset_location = pageConfig.new_asset_location_name +'-' +pageConfig.new_asset_location_supplement
          }
        let param = {
          asset_id: pageConfig.asset_id, //资产id
          asset_name: pageConfig.asset_name, //资产名称
          asset_code: pageConfig.asset_code, //资产代码
          custodian_dept_id: pageConfig.custodian_dept_id, //保管部门id
          custodian_dept_name: pageConfig.custodian_dept_name, //保管部门名称
          custodian_emp_name: pageConfig.custodian_emp_name, //保管人名称
          custodian_emp_id: pageConfig.custodian_emp_id, //保管人id
          asset_status: pageConfig.asset_status, //原资产状态
          asset_status_name: pageConfig.asset_status_name, //原资产状态
          asset_location: pageConfig.asset_location, //原位置
          station_code: pageConfig.station_code, //原站点
          new_custodian_emp_name: pageConfig.new_custodian_emp_name, //新保管人
          new_custodian_emp_id: pageConfig.new_custodian_emp_id, //新保管人
          new_custodian_emp_code: pageConfig.new_custodian_emp_code, //新保管人
          new_custodian_dept_name: pageConfig.new_custodian_dept_name, //新保管部门
          new_custodian_dept_code: pageConfig.new_custodian_dept_code, //新保管部门
          new_custodian_dept_id: pageConfig.new_custodian_dept_id, //新保管部门
          new_asset_status_name: pageConfig.new_asset_status_name, //新资产状态
          new_asset_status: pageConfig.new_asset_status, //新资产状态
          new_asset_location: pageConfig.new_asset_location, //新位置
          location_mapping: pageConfig.location_mapping, //新位置xx
          new_station_name: pageConfig.new_station_name, //新站点
          new_station_code: pageConfig.new_station_code, //新站点
        }
        emit('onclose', param, props.rowdata)
      },
    }
    onMounted(() => {
      methods.init()
    })
    return {
      pageConfig,
      methods,
    }
  },
}
</script>
<style scoped lang="scss">
.TransferPop {
  .form {
    height: calc(100vh - 60px);
    overflow: auto;
  }
  .column-block {
    padding: 5px;
  }
  .van-loading {
    text-align: center;
    position: absolute;
    z-index: 9999999;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background-color: #fff;
    border-radius: 10px;
    left: calc(50% - 40px);
    top: 25vh;
  }
  .file_block {
    .file_name {
      margin: 0 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .bottom {
    height: 50px;
    background-color: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
  }
}
</style>
